<template>
  <footer class="m-auto w-full py-3 px-4 sm:px-6 mx-auto mt-8">
    <div class="flex justify-between items-center gap-5">
      <p class="text-xs">Version <a href="https://github.com/c1bles/nominal-reader/releases/tag/1.1.0" target="_blank" class="underline">1.1.0</a>.</p>
      <p class="text-xs"><a href="https://github.com/c1bles/nominal-reader/" target="_blank" class="underline">Github</a></p>
      <p class="text-xs"><a href="https://discord.gg/nqzP6VKwMs" target="_blank" class="underline">Discord</a></p>
    </div>
  </footer>
</template>
<script>

export default {
  name: 'AppFooter'
}
</script>
